"use strict";
export default (() => {
  const autofocus = document.querySelectorAll("[data-autofocus]");
  if (autofocus.length === 0)
    return;
  autofocus.forEach((input) => {
    const containerType = input.dataset.autofocus;
    if (containerType === "modal" || containerType === "collapse" || containerType === "offcanvas" || containerType === "dropdown") {
      const container = input.closest("." + containerType);
      container.addEventListener(`shown.bs.${containerType}`, () => {
        input.focus();
      });
    } else {
      input.focus();
    }
  });
})();
